// extracted by mini-css-extract-plugin
module.exports = {"FQAContainer":"FQA_FQAContainer__1KH9H","leftContent":"FQA_leftContent__1T84g","midContent":"FQA_midContent__bmtja","rightContent":"FQA_rightContent__T8q3i"};